module.exports = __webpack_public_path__ + "static/media/product21.37c5af4b.jpg";